// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "MiniCard-module--bx--text-truncate--end--1f64H";
export var bxTextTruncateFront = "MiniCard-module--bx--text-truncate--front--1ZfKg";
export var card = "MiniCard-module--card--3lVe7";
export var icon = "MiniCard-module--icon--fEXzT";
export var image = "MiniCard-module--image--tkMgV";
export var title = "MiniCard-module--title--3E2th";
export var wrapper = "MiniCard-module--wrapper--SkRrV";